export default {
  requestTimeoutMs: 30000,
};
